import { createReducer } from 'utils/redux'
import { validateSkills, validateTargetingConditions } from 'utils/validate'

const DEFAULT_STATE = {}

const validatePlaybook = ({ draft, action }) => {
  const { connectedCalendars, orgUsers, orgTeams } = action
  const { actions = [], meta = {}, targeting = {} } = action.playbook
  const { actions: experimentActions = [] } = action.playbook.experiment || {}
  const { driftLinkOnly = false } = meta
  const { display = [] } = targeting

  const interaction = actions[0]?.action ?? {}
  const experimentInteraction = experimentActions[0]?.action ?? {}

  /* reset draft and re-calculate playbook errors
     on every update to playbook data */
  draft = {}

  const invalidExperimentSkills = validateSkills(
    experimentInteraction.skills,
    experimentInteraction.displayOrder,
    'EXPERIMENT',
    action.blocksById,
    connectedCalendars,
    orgTeams,
    orgUsers
  )

  const invalidSkills = validateSkills(
    interaction.skills,
    interaction.displayOrder,
    'BUILDER',
    action.blocksById,
    connectedCalendars,
    orgTeams,
    orgUsers
  )

  const invalidTargetingConditions = !driftLinkOnly
    ? validateTargetingConditions(display)
    : {}

  draft = {
    playbook: { ...invalidSkills },
    experiment: { ...invalidExperimentSkills },
    ...invalidTargetingConditions,
  }
  return draft
}

const actions = {
  VALIDATE_PLAYBOOK: validatePlaybook,
}

const playbookErrorsReducer = createReducer(DEFAULT_STATE, actions)

export default playbookErrorsReducer
